export default __webpack_public_path__ + "static/media/ellipsis-h-dark.16423f09.svg";